import { render } from "./_blank_page.vue?vue&type=template&id=a8c8d19c"
import script from "./_blank_page.vue?vue&type=script&lang=js"
export * from "./_blank_page.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__